/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_FieldsInputs */

const cs_property_ai_fields = /** @type {(inputs: Property_Ai_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole k překladu`)
};

const en_property_ai_fields = /** @type {(inputs: Property_Ai_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields to translate`)
};

/**
* | output |
* | --- |
* | "Fields to translate" |
*
* @param {Property_Ai_FieldsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_fields = /** @type {((inputs?: Property_Ai_FieldsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_FieldsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_fields(inputs)
	return cs_property_ai_fields(inputs)
});